import Section from './TermsBlock'
import isEmpty from './TermsIsEmpty'

export default { isEmpty, Section }
